<template>
  <!-- 侧边栏购物车 -->
  <div class="w-full">
    <n-drawer
      v-model:show="show"
      :z-index="999999"
      :on-after-enter="getcarlist"
      placement="right"
      :style="{
        'background-color': color?.cartBgColor,
        'color': color?.cartTextColor,
      }"
      class="w-100% bg-#FFF px26px pt44px color-#000 max-md:p-0 max-md:w-90%! md:!w550px"
    >
      <n-drawer-content
        :style="{
          '--n-close-icon-color': `${color?.cartTextColor ? color?.cartTextColor : '#000'}`,
        }"
        footer-style="border:none;"
        header-style="border:none;"
        closable
      >
        <template #header>
          <p
            class="uppercase"
            :style="{
              color: color?.cartTextColor,
            }"
          >
            {{ $t('headers.cart') }}
          </p>
        </template>
        <n-spin :show="loading">
          <div v-if="carList?.line_items?.length" class="w-100%">
            <div
              v-for="(item, index) in carList.line_items"
              :key="index"
              class="w-100% flex items-start py10px md:py17px"
            >
              <div class="flex items-center">
                <n-checkbox
                  v-model:checked="item.isSelected"
                  :disabled="item.status !== '1'"
                />
                <sps-img
                  fit="contain"
                  class="mx-15px aspect-ratio-3/4 min-w-80px w-80px flex-center"
                  :src="item.status !== '1' ? '' : item.image.src"
                  @click="$router.push(`/products/${item.product_id}`)"
                />
              </div>
              <div class="flex-col grow-1 justify-between gap-2 text-14px">
                <div class="line-clamp-1 flex cursor-pointer justify-between color-productTitleColor">
                  <span @click="$router.push(`/products/${item.product_id}`)">
                    {{ item.product_title }}</span>
                </div>
                <nuxt-link
                  :style="{
                    color: color?.cartTextColor,
                  }"
                  :to="`/products/${item.handle}`"
                  class="w-full flex-col flex-wrap gap-2 color-#8D8D8D"
                >
                  <span v-for="i in item.options" :key="i.name">
                    <span class="font-600">
                      {{ i.name }}:
                    </span>
                    {{ i.value }}</span>
                  <!-- <span class=" m-l15px">256G</span> -->
                </nuxt-link>
                <div class="flex flex-wrap items-center justify-between gap-2">
                  <div class="order-last flex items-center gap-x-14px gap-y-12px">
                    <n-button
                      class="h-8 w-8 text-32px p-0!"
                      :disabled="item.quantity <= 0"
                      @click="changeGoodsNum(item, -1)"
                    >
                      <icon name="icon:minus" class="h-4 w-4" />
                    </n-button>
                    <span>{{ item.quantity }}</span>
                    <n-button
                      class="h-8 w-8 text-25px p-0!"
                      :disabled="Number(item.quantity) >= Number(item.available_quantity)"
                      @click="changeGoodsNum(item, 1)"
                    >
                      <icon name="icon:addBtn" class="h-4 w-4" />
                    </n-button>
                    <n-button text>
                      <icon name="icon:del" class="h-5.5 w-5.5 flex-1" @click="removeCar(item)" />
                    </n-button>
                  </div>
                  <p class="color-[--price]!">
                    {{ formatPrice(bundleIds.includes(item.id) ? item.quantity * (+item.price) : item.quantity * (+item.price + +item.cost_price)) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="flex-center flex-col">
            <icon name="icon:cart" class="h-200px w-100px" />
            <div>{{ $t('cart.cart_empty') }}</div>
            <NuxtLink
              href="/"
              class="link uppercase"
              style="
                margin-top: 20px;
                font-size: 15px;
                letter-spacing: 1px;
                line-height: 18px;
                cursor: pointer;
                display: inline-flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                text-decoration: none solid rgb(255, 255, 255);
                border: 1px solid rgba(0, 0, 0, 0);
                background-color: rgb(18, 18, 18);
                color: rgb(255, 255, 255);
                min-width: 320px;
                min-height: 45px;
                transition: all 0.1s linear 0s;
                appearance: none;
                outline: rgb(255, 255, 255) none 0px;
              "
              @click="show = false"
            >
              {{ $t('cart.cart_empty_btn') }}
            </NuxtLink>
          </div>
        </n-spin>

        <template #footer>
          <div v-if="carList?.line_items?.length" class="w-full">
            <div class="flex items-center justify-between text-16px uppercase">
              <span>{{ $t('headers.total') }}</span>
              <span>{{ formatPrice(cartotalprice) }}</span>
            </div>
            <div v-if="bundleSave" class="w-100% flex items-center justify-between font-400">
              <div class="text-4 text-black uppercase">
                {{ $t('cart.bundle_save') }}:
              </div>
              <div class="text-4 color-black">
                -{{ formatPrice(bundleSave) }}
              </div>
            </div>
            <n-button
              :disabled="!carIds.length"
              :loading="buynowloading"
              type="primary"
              block
              :color="color?.cartCheckOutBgColor ? color.cartCheckOutBgColor : '#000'"
              :text-color="color?.cartCheckOutTextColor ? color.cartCheckOutTextColor : '#fff'"
              style="height: 50px"
              class="p-12px text-center text-14px uppercase md:text-16px"
              @click="buyNow"
            >
              {{ $t('headers.buynow') }}
            </n-button>

            <nuxt-link to="/cart" style="height: 50px" @click="setCarShow">
              <n-button
                style="height: 50px"
                type="primary"
                :color="color?.cartViewBgColor ? color.cartViewBgColor : '#000'"
                :text-color="color?.cartViewTextColor ? color.cartViewTextColor : '#fff'"
                block
                class="mt-20px p-12px text-center text-16px uppercase"
              >
                {{ $t('headers.checkcart') }}
              </n-button>
            </nuxt-link>
          </div>
        </template>
      </n-drawer-content>
    </n-drawer>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  carShow: boolean
}>()

const { color } = storeToRefs(useThemeEditorStore())

const {
  bundleIds,
  bundleSave,
  loading,
  buyNow,
  removeCar,
  buynowloading,
  getcarlist,
  carIds,
  carList,
  cartotalprice,
  changeGoodsNum,
} = useCart()
/**  显示/隐藏 购物车 */
const show = defineModel<boolean>('carShow')

onBeforeMount(() => {
  if (show.value)
    getcarlist()
})

const setCarShow = () => {
  show.value = false
}
</script>
